import type { FC } from "react";
import styles from "./StepContainer.module.css";

interface StepContainerProps {
  children?: React.ReactNode;
}

export const StepContainer: FC<StepContainerProps> = ({ children }) => {
  return <section className={styles.stepContainer}>{children}</section>;
};
